import { Card, Placeholder } from "react-bootstrap";

interface Props {
  isXS?: boolean;
}

const ProductSkeletonCard = ({ isXS }: Props) => {
  return (
    <Card border="light" style={{ boxShadow: "0 4px 8px 0 rgba(0, 0, 0, 0.2)" }}>
      <div 
        style={{ 
          height: isXS ? '200px' : '300px', 
          backgroundColor: '#e9ecef', 
          borderTopLeftRadius: 'calc(.25rem - 1px)', 
          borderTopRightRadius: 'calc(.25rem - 1px)' 
        }} 
        className="placeholder-glow"
      >
        <span className="placeholder w-100 h-100"></span>
      </div>
      <Card.Body className="d-flex flex-column h-100">
        <Placeholder as={Card.Title} animation="glow" className="mb-1">
          <Placeholder xs={9} />
        </Placeholder>
        <Placeholder as={Card.Title} animation="glow" className="mb-2">
          <Placeholder xs={5} />
        </Placeholder>
        <Placeholder as={Card.Text} animation="glow" className="mb-3 flex-grow-1">
          <Placeholder xs={7} /> <Placeholder xs={4} /> <Placeholder xs={6} />
        </Placeholder>
        <Placeholder as="div" animation="glow" className="mt-auto">
          <Placeholder xs={12} className="rounded-pill" style={{ height: '31px' }} />
        </Placeholder>
      </Card.Body>
    </Card>
  );
};

export default ProductSkeletonCard;
